import { ModuleDefault } from '../default';
import { IResponse, merchant } from '@dto';

export class Create extends ModuleDefault {
  public create (body: merchant.ICreate): Promise<IResponse<merchant.ICreate>> {
    return this.request.post<IResponse<merchant.ICreate>>(`${this.setup.urlBase}/merchants`, body);
  }
}
